module.exports = __webpack_public_path__ + "static/media/Profile-Moderator-02-IIhami-Ozturk.7c441cd8.png";